import styled, { css } from "styled-components";

import { transition } from "@ui/helpers";

export const Root = styled.div`
  position: relative;
`;

export const Viewport = styled.div<{
  $slidesPerViewTablet?: number;
  $slidesPerViewDesktop?: number;
}>`
  --slide-size: 73%;
  --slide-spacing: ${({ theme }) => theme.spacing.spacing_32};

  position: relative;
  width: 100%;

  ${({ theme }) => theme.breakpointsV2.smallTablet} {
    --slide-size: calc(
      100% / ${({ $slidesPerViewTablet }) => $slidesPerViewTablet || "3"}
    );
    --slide-spacing: ${({ theme }) => theme.spacing.spacing_24};

    width: 100%;
    overflow: hidden;
  }

  ${({ theme }) => theme.breakpointsV2.smallDesktop} {
    --slide-size: calc(
      100% / ${({ $slidesPerViewDesktop }) => $slidesPerViewDesktop || "3"}
    );
    --slide-spacing: ${({ theme }) => theme.spacing.spacing_32};
  }
`;

export const Container = styled.div`
  margin-left: calc(var(--slide-spacing) * -1);
  margin-right: 50px;

  backface-visibility: hidden;
  display: flex;
  touch-action: pan-y pinch-zoom;

  ${({ theme }) => theme.breakpointsV2.smallTablet} {
    margin-right: 0;
  }
`;

export const Slide = styled.div`
  flex: 0 0 var(--slide-size);
  padding-left: var(--slide-spacing);
  min-width: 278px;

  ${({ theme }) => theme.breakpointsV2.smallTablet} {
    min-width: 0px;
  }
`;

export const ArrowButton = styled.button<{
  $version: "prev" | "next";
  $isActive: boolean;
}>`
  all: unset;
  --arrow-margin: -21px;

  box-sizing: border-box;
  padding: ${props => props.theme.spacing.spacing_4};
  position: absolute;
  top: 50%;
  width: 42px;
  height: 42px;
  border: 1px solid ${props => props.theme.palette.grey800};
  border-radius: 50%;
  background-color: ${props => props.theme.palette.white};
  color: ${props => props.theme.palette.grey800};
  transition: ${transition("opacity")};
  opacity: 0;
  z-index: 1;
  pointer-events: none;
  cursor: pointer;
  align-items: center;
  justify-content: center;

  display: none;

  ${props => props.theme.breakpointsV2.smallTablet} {
    display: flex;
  }

  ${props =>
    props.$isActive &&
    css`
      opacity: 1;
      pointer-events: all;
    `}

  ${props =>
    props.$version === "prev" &&
    css`
      left: 0;
      transform: translate(calc(-100% - var(--arrow-margin)), -50%);
    `}
  
    ${props =>
    props.$version === "next" &&
    css`
      right: 0;
      transform: translate(calc(100% + var(--arrow-margin)), -50%);
    `}
`;
